import React from 'react';
import { Icon, Warning } from 'venn-ui-kit';
import { SubjectList } from 'venn-components';
import { isFactorTrendMetric, plural } from 'venn-utils';
import { PanelFlexHeader, Section } from '../../../shared';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  rightPanelExcludedSubjects,
  rightPanelMaxSubjects,
  rightPanelSelectedBlock,
  selectedBlockSettings,
  rightPanelSubjects,
} from 'venn-state';

export interface ObjectsSectionProps {
  readonly?: boolean;
  hideAllocatorLauncher?: boolean;
}

/**
 * @deprecated this component will soon be replaced in Input Management V2.
 * If you make changes here, consider making similar changes to {@link AnalysisBlockTabV2}.
 */
const ObjectsSection = ({ readonly, hideAllocatorLauncher }: ObjectsSectionProps) => {
  const block = useRecoilValue(rightPanelSelectedBlock);
  const blockSettings = useRecoilValue(selectedBlockSettings);
  const isPortfolioOnlyBlock = blockSettings?.customBlockType === 'PORTFOLIO_CONTRIBUTION';
  const isFactorTrendLineChart = block?.infoGraphicType === 'LINE' && isFactorTrendMetric(block?.selectedMetrics);
  const [subjects, setSubjects] = useRecoilState(rightPanelSubjects);
  const maxSubjects = useRecoilValue(rightPanelMaxSubjects);
  const excludedSubjects = useRecoilValue(rightPanelExcludedSubjects);
  const multiSubject = subjects.length > 1;

  return (
    <Section>
      <PanelFlexHeader>
        {!isPortfolioOnlyBlock && <Icon type="square" />}
        <Icon type="th" />
        <span>{isPortfolioOnlyBlock ? '' : 'Investments & '}Portfolios</span>
      </PanelFlexHeader>

      {excludedSubjects > 0 && (
        <Warning
          text={`This block accommodates a max of ${maxSubjects} object. ${excludedSubjects} linked global 
        ${plural(excludedSubjects, { 1: 'object has', other: 'objects have' })} been excluded`}
        />
      )}

      {isFactorTrendLineChart && multiSubject && (
        <Warning text="For best results select a single factor or a single investment/portfolio." />
      )}

      <SubjectList
        readonly={readonly}
        subjects={subjects}
        setSubjects={setSubjects}
        portfoliosOnly={isPortfolioOnlyBlock}
        hideAllocatorLauncher={hideAllocatorLauncher}
        maxSubjects={maxSubjects}
      />
    </Section>
  );
};

export default ObjectsSection;
